import {first, map, takeUntil, tap} from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';
import { ItemService } from '../services'
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { of, Subject } from "rxjs";
import * as moment from 'moment';
import { ItemContextModel } from '../model';

@Component({
    selector: 'recommended-pane',
    styles: [`
        mat-card {
            margin-bottom: 6px;
        }
        
        .title {
            font-size: 20px;
        }

        .itemsPanel {
            overflow-y: auto;
            height: calc(100vh - 130px);
        }
    `],
    template: `
        <div *ngIf="noTouching && !showItem" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner></spinner>
        </div>
        <div fxLayout="column" *ngIf="!noTouching && !showItem">
            <mat-card>
                <mat-card-content>
                    <mat-card-title class="title">Recommended</mat-card-title>
                </mat-card-content>
            </mat-card>
            <div class="itemsPanel"
                 infiniteScroll 
                 [infiniteScrollThrottle]="300"
                 [infiniteScrollDistance]="1"
                 [scrollWindow]="false"
                 (scrolled)="retrievePage()">
                <span *ngFor="let item of items">
                    <item-summary [item]="item"></item-summary>
                </span>
            </div>
        </div>
    `})
export class RecommendedPane implements OnDestroy {
    private cleanupTime = new Subject<void>();
    items: any = [];
    noTouching: boolean = true;
    showItem: boolean = false;
    itemSearchParams = { page: -1 };

    constructor(private router: Router, private route: ActivatedRoute, private itemService: ItemService){}

    ngOnInit(): void {
        this.route.url.pipe(takeUntil(this.cleanupTime)).subscribe((segs: UrlSegment[]) => {
            if (segs.length) {
                this.itemService.focusedItemEdit.next(undefined);
                const itemId = segs[1].path;
                let item = this.items.find(item => item.id === itemId);
                const isSource = false; 
                const curating = false;
                if (!item) {
                    this.itemService.getItem(itemId)
                    .pipe(map(response => response.item))
                    .subscribe(fetchedItem => this.itemService.focusedItem.next(new ItemContextModel(fetchedItem, undefined, undefined, undefined, isSource, curating)));
                } else {
                    this.itemService.focusedItem.next(new ItemContextModel(item, undefined, undefined, undefined, isSource, curating));
                }
            } else {
                this.itemService.focusedItem.next(undefined);
            }
        });
        this.itemService.itemClosing.pipe(takeUntil(this.cleanupTime)).subscribe(() => this.router.navigateByUrl(this.itemService.childClearedPath()));
        this.itemService.itemContextChanged.pipe(takeUntil(this.cleanupTime)).subscribe(() => {
            this.itemSearchParams = { page: -1 };
            this.fetchItems();
        });
        this.router.events.pipe(takeUntil(this.cleanupTime)).subscribe(() => this.showItem = !!this.route.firstChild );
        this.fetchItems();
    };

    retrievePage = () => {
        this.itemSearchParams.page++;
        return this.itemService.searchTenantItems({ 
            page: this.itemSearchParams.page, 
            includeFullDescription: true, 
            sortField: 'attentionRank',
            createdAfterDateTime: moment().subtract(90, 'days').toISOString()
        })
        .pipe(
            tap(itemResults => {
                itemResults.content.forEach(item => {
                    item.visible = true;
                    this.items.push(item);
                });
            })
        );
    }

    fetchItems = () => {
        this.noTouching = true;
        this.retrievePage().subscribe(() => this.noTouching = false);
    };

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    };
}
